// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".closed-tickets__synced {\n  margin-bottom: 1.2rem;\n}", "",{"version":3,"sources":["webpack://./src/modules/HealthClaims/ClosedTickets/closed-tickets.scss"],"names":[],"mappings":"AAGE;EACE,qBAAA;AAFJ","sourcesContent":["@import '../../../styles/theme';\n\n.closed-tickets {\n  &__synced {\n    margin-bottom: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
